import { CarPdfViewer } from "@app/components/PdfViewer";
import { useSearchParams } from "react-router-dom";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { CarPdfPage, defaultClientPageSize } from "@app/components/PdfPage";
import { useUser } from "@app/pages/settings/useUser";
import { assetClassAnalysisPages } from "@app/const/route.const";
import { SectorAnalysisPdfChart } from "./SectorAnalysisPdfChart";
import { SectorAnalysisSummaryPdfTable } from "./SectorAnalysisSummaryPdfTable";
import { useAssetClassAnalysisSectorAnalysis } from "../useAssetClassAnalysisSectorAnalysis";
import { SectorAnalysisFocusPdfTable } from "./SectorAnalysisFocusPdfTable";
import { CarPdfTypography } from "@app/components/PdfTypography";

const SECTOR_ANALYSIS_CHART_HEIGHT = 470;

export const PdfSectorAnalysisReportPage = () => {
  const [searchParams] = useSearchParams();
  const { assetClass1Id, assetClass2Id, sectorFocusId } =
    assetClassAnalysisPages.getPdfSectorAnalysisReportParams(searchParams);

  const data = useAssetClassAnalysisSectorAnalysis();

  const sectorFocusItem = data.report.level1.find(
    (i) => i.id === sectorFocusId,
  );

  const user = useUser();

  const ac1Label = data.chartItems.find((i) => i.id === assetClass1Id)?.label;

  const ac2Label = data.chartItems.find((i) => i.id === assetClass2Id)?.label;

  const title = `Sector Analysis ${ac1Label} vs. ${ac2Label}`;
  const footer = "Asset Class Analysis";

  return (
    <CarPdfViewer isLoading={user.isLoading || data.isLoading}>
      <CarPdfDocument title={title} author={user.userFullName}>
        {
          <CarPdfPage
            reportTitle="Sector Analysis"
            sectionTitle="Historical Analysis"
            footer={footer}
          >
            <SectorAnalysisPdfChart
              style={{ marginTop: 18 }}
              width={defaultClientPageSize.width}
              height={SECTOR_ANALYSIS_CHART_HEIGHT}
              data={data.chartItems}
              report={data.report}
              data1Id={assetClass1Id}
              data2Id={assetClass2Id}
              isWhiteContext
            />
            <SectorAnalysisSummaryPdfTable
              break
              data={data.chartItems}
              report={data.report}
              data1Id={assetClass1Id}
              data2Id={assetClass2Id}
            />
            {sectorFocusItem && (
              <>
                <CarPdfTypography
                  style={{ marginTop: 28, marginBottom: 16 }}
                  variant="v14Semibold"
                  dense
                >
                  {`Sector Focus - ${sectorFocusItem.name}`}
                </CarPdfTypography>
                <SectorAnalysisFocusPdfTable
                  data={data.chartItems}
                  sectorFocusItem={sectorFocusItem}
                  data1Id={assetClass1Id}
                  data2Id={assetClass2Id}
                />
              </>
            )}
          </CarPdfPage>
        }
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
